import { Link } from 'react-router-dom';
import '../../styles/EventsSection.css';
import foot from '../../assets/foot.webp';

const eventsData = [
  {
    id: 2,
    title: "The Crown Championship 2026 ⚽",
    sport: " Football ⚽",
    date: "July 27, 2026",
    venue: "Elgin Turf, Kolkata",
    time: "10:00 AM - 6:00 PM",
    description: "5-a-side football tournament with exciting cash prizes. 16 teams battling for the championship! Open for all age groups.",
    teams: "16 Teams",
    booked: "Slot Booking Fast",
    status: "upcoming",
    image: foot,
    organizer: "Verna Events",
    prize: "🏆 Trophy + ₹18,000 Cash Prize",
    
  }
];

function EventsSection() {
  return (
    <section className="evs-section-wrapper">
      {/* Animated Background */}
      <div className="evs-bg-glow evs-bg-glow-1"></div>
      <div className="evs-bg-glow evs-bg-glow-2"></div>

      <div className="evs-container">
        {/* Section Header */}
        <div className="evs-header-wrapper">
          <div className="evs-header-left">
            <div className="evs-badge-wrapper">
              <span className="evs-badge-dot"></span>
              <span className="evs-section-badge">🔥 Upcoming Events</span>
            </div>
            <h2 className="evs-title">
              Don't Miss Out on <br />
              <span className="evs-title-highlight">Exciting Tournaments</span>
            </h2>
            <p className="evs-subtitle">
              Every tournament has a story waiting to be written. Will you be part of it?
              Register your team and create your winning moment!
            </p>
            <div className="evs-story-badge">
              <span>🏆</span>
              <span>1 Event • 10+ Teams Registering</span>
            </div>
          </div>
          <div className="evs-header-right">
            <Link to="/events" className="evs-view-all-btn">
              View All Events
              <svg className="evs-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
          </div>
        </div>

        {/* Events Grid */}
        <div className="evs-grid-wrapper">
          {eventsData.map((event) => (
            <div key={event.id} className="evs-card-wrapper">
              {/* Card Glow Effect */}
              <div className="evs-card-glow"></div>
              
              {/* Event Image */}
              <div className="evs-card-image">
                <img 
                  src={event.image} 
                  alt={event.title}
                  loading="lazy" // ✅ Lazy Loading Added
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/600x350?text=Sports+Event';
                  }}
                />
                <div className="evs-image-overlay">
                  <span className="evs-status-badge">
                    <span className="evs-status-dot"></span>
                    Upcoming
                  </span>
                  <div className="evs-sport-icon">{event.sport.split(' ')[0]}</div>
                </div>
              </div>

              {/* Event Body */}
              <div className="evs-card-body">
                <div className="evs-card-header">
                  <span className="evs-sport-name">{event.sport}</span>
                  <span className="evs-fee">{event.fee}</span>
                </div>

                <h3 className="evs-event-title">{event.title}</h3>
                <p className="evs-event-desc">{event.description}</p>

                {/* Event Details Grid */}
                <div className="evs-details-grid">
                  <div className="evs-detail-item">
                    <span className="evs-detail-icon">📅</span>
                    <div>
                      <span className="evs-detail-label">Date</span>
                      <span className="evs-detail-value">{event.date}</span>
                    </div>
                  </div>
                  <div className="evs-detail-item">
                    <span className="evs-detail-icon">⏰</span>
                    <div>
                      <span className="evs-detail-label">Time</span>
                      <span className="evs-detail-value">{event.time}</span>
                    </div>
                  </div>
                  <div className="evs-detail-item">
                    <span className="evs-detail-icon">📍</span>
                    <div>
                      <span className="evs-detail-label">Venue</span>
                      <span className="evs-detail-value">{event.venue}</span>
                    </div>
                  </div>
                  <div className="evs-detail-item">
                    <span className="evs-detail-icon">👥</span>
                    <div>
                      <span className="evs-detail-label">Teams</span>
                      <span className="evs-detail-value">{event.teams}</span>
                    </div>
                  </div>
                </div>

                {/* Booking Progress */}
                <div className="evs-booking-progress">
                  <div className="evs-progress-header">
                    <span>Booking Progress</span>
                    <span className="evs-progress-text">{event.booked}</span>
                  </div>
                  <div className="evs-progress-bar">
                    <div 
                      className="evs-progress-fill" 
                      style={{ 
                        width: '65%',
                        background: 'linear-gradient(90deg, #f7971e, #ffd200)'
                      }}
                    ></div>
                  </div>
                </div>

                {/* Organizer & Prize */}
                <div className="evs-extra-info">
                  <div className="evs-organizer">
                    <span className="evs-extra-icon">👤</span>
                    <span>{event.organizer}</span>
                  </div>
                  <div className="evs-prize">
                    <span className="evs-extra-icon">🏅</span>
                    <span>{event.prize}</span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="evs-actions">
                  <Link to={`/events/${event.id}`} className="evs-detail-btn">
                    View Details
                    <svg className="evs-btn-arrow-small" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </Link>
                  <Link to={`/register/${event.id}`} className="evs-register-btn">
                    Register Now
                    <svg className="evs-btn-arrow-small" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Story CTA */}
        <div className="evs-bottom-cta">
          <div className="evs-bottom-content">
            <div className="evs-bottom-left">
              <span className="evs-story-icon">📖</span>
              <div>
                <h4>Every Champion Has a Story</h4>
                <p>
                  From practice to victory, every team has a journey. 
                  Your story starts here. Register now and become part of the legacy!
                </p>
              </div>
            </div>
            <Link to="/events" className="evs-story-btn">
              Start Your Journey
              <svg className="evs-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EventsSection;